export function CopyIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.333 13.333C2.417 13.333 1.667 12.583 1.667 11.667V3.333C1.667 2.417 2.417 1.667 3.333 1.667H11.667C12.583 1.667 13.333 2.417 13.333 3.333M8.333 6.667H16.667C17.587 6.667 18.333 7.413 18.333 8.333V16.667C18.333 17.587 17.587 18.333 16.667 18.333H8.333C7.413 18.333 6.667 17.587 6.667 16.667V8.333C6.667 7.413 7.413 6.667 8.333 6.667Z"
        stroke="#3C91E6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
